module.exports = __webpack_public_path__ + "static/img/hover-iocn73.56c7d4b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_icon/hover-iocn73.svg
// module id = OqSZ
// module chunks = 3